import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useDidMount } from 'rooks';

import * as audioFunctions from 'root/lib/audioFunctions';
import { exitActivityToWorkshop } from '../../../../../actions/workshopActions';
import { ModalContainer } from '../sharedComponents';
import AnimatedBurst from '../sharedComponents/AnimatedBurst';
import SmallBackground from '../svgs/Common/SmallBackground.svg';
import { Background, DescriptionText, FailureText, ContinueButton } from './styledComponents';

const GameFailureModal = ({ closeModal, config }) => {
  const dispatch = useDispatch();

  const onGoToWorkshopButtonPress = () => {
    audioFunctions.playTap(true);
    closeModal();
    dispatch(exitActivityToWorkshop(config));
  };

  useDidMount(() => {
    audioFunctions.playPop();
  });

  return (
    <ModalContainer
      role="dialog"
      aria-modal="true"
      aria-labelledby="game-failure-modal-title"
      data-dd-action-name="game-failure-modal"
    >
      <AnimatedBurst />
      <Background src={SmallBackground} alt="" />
      <FailureText id="game-failure-modal-title">NICE TRY</FailureText>
      <DescriptionText>
        That was challenging.{'\n'}
        We&apos;ll come back to this!
      </DescriptionText>
      <ContinueButton
        onClick={onGoToWorkshopButtonPress}
        data-dd-action-name="game-failure-modal:continue"
      >
        Go To Workshop
      </ContinueButton>
    </ModalContainer>
  );
};

GameFailureModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
};

export default GameFailureModal;
